// extracted by mini-css-extract-plugin
export default {"sendOrderDivOrder":"SendOrderMode_sendOrderDivOrder__1t8zW","sendOrderButtonDynamic":"SendOrderMode_sendOrderButtonDynamic__7HcbW"};